import api from "../../axiosConfig";

export const addInstruction = async (formData) => {
    const token= sessionStorage.getItem('token');
    try {

      const response = await api.post('instruction/add-instruction', formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getInstruction = async (searchKeyword,doctor_id) => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get('/instruction/all-instruction', {
      params: {
        search_keyword: searchKeyword,
        doctor_id:doctor_id
      },
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching receptionist');
    
  }
};

export const updateInstruction = async (id, formData) => {
  const token = sessionStorage.getItem('token');

  // Append required format values
  const payload = {
    ...formData,
    id: parseInt(id),
    _method: 'put', // Required for Laravel-style method spoofing
  };
  console.log('Payload for update:', payload);
  console.log('ID for update:', id);  
  try {
    const response = await api.post(`/instruction/update-instruction/${id}`, payload
    );
    

    const resData = response?.data;
    console.log('Update receptionist response:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData };
    } else {
      return { success: false, error: resData.message };
      
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error updating receptionist');
  }
};
export const deleteInstruction = async (id) => {
  try {
    const response = await api.delete(`instruction/delete/${id}`);

    const resData = response?.data;
    console.log('Delete instruction response:', resData);

    if (resData?.message_type === 'success') {
      return { success: true, data: resData.message };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error deleting instruction');
  }
};